(function () {
  if (window.__productListRowInit) return;
  window.__productListRowInit = true;

  function showComboError(element, message) {
    var errElem = null;
    if (element && element.matches && element.matches('[data-combo-modal-error]')) {
      errElem = element;
    } else if (element && element.dataset && element.dataset.errorSelector) {
      errElem = document.querySelector(element.dataset.errorSelector);
    }
    if (!errElem) return;
    var errSpan = errElem.querySelector('[data-error]');
    if (!message) {
      errElem.classList.add('hidden');
      if (errSpan) errSpan.textContent = '';
      return;
    }
    errElem.classList.remove('hidden');
    if (errSpan) errSpan.textContent = message;
  }

  function openCartDrawer(element) {
    if (element.dataset.redirect) {
      window.location.href = element.dataset.redirect;
      return;
    }
    if (element.dataset.modal !== 'true') return;
    var isModal = document.querySelector('[data-modal="modal-cart-drawer"]');
    if (!isModal) return;
    if (isModal.classList.contains('modal--active')) {
      if (typeof trapFocus === 'function') trapFocus(isModal);
    } else {
      var drawerToggler = document.querySelector(element.dataset.modalRef);
      if (drawerToggler) drawerToggler.dispatchEvent(new Event('click'));
    }
  }

  function getPickerData(picker) {
    var jsonEl = picker.querySelector('[data-combo-product-json]');
    if (!jsonEl) return null;
    try {
      return JSON.parse(jsonEl.textContent);
    } catch (error) {
      return null;
    }
  }

  function getSelectedOptions(picker) {
    var options = ['', '', ''];
    picker.querySelectorAll('input[type="radio"][data-combo-option]:checked').forEach(function (input) {
      var index = parseInt(input.dataset.comboOption, 10) - 1;
      if (index >= 0 && index < 3) options[index] = input.value;
    });
    return options;
  }

  function findMatchingVariant(data, options) {
    if (!data || !data.variants) return null;
    return (
      data.variants.find(function (variant) {
        for (var i = 0; i < 3; i++) {
          if (!options[i]) continue;
          if (variant['option' + (i + 1)] !== options[i]) return false;
        }
        return true;
      }) || null
    );
  }

  function resolveOptions(picker, data, partialOptions) {
    var options = partialOptions ? partialOptions.slice() : getSelectedOptions(picker);
    var match = findMatchingVariant(data, options);

    if (match) {
      for (var i = 0; i < 3; i++) {
        if (!options[i] && data.options[i]) {
          options[i] = match['option' + (i + 1)];
        }
      }
    }

    return options;
  }

  function getResolvedVariant(picker, data, partialOptions) {
    var options = resolveOptions(picker, data, partialOptions);
    return findMatchingVariant(data, options);
  }

  function setInputAvailability(input, isAvailable) {
    var label = input.nextElementSibling;
    if (isAvailable) {
      input.classList.remove('disabled');
      if (label) label.classList.remove('disabled');
    } else {
      input.classList.add('disabled');
      if (label) label.classList.add('disabled');
    }
  }

  function updatePickerAvailability(picker) {
    var data = getPickerData(picker);
    if (!data) return null;

    var fieldsets = picker.querySelectorAll('.product-list-combo-picker__fieldset');

    fieldsets.forEach(function (fieldset) {
      var inputs = fieldset.querySelectorAll('input[type="radio"][data-combo-option]');
      inputs.forEach(function (input) {
        var testOptions = getSelectedOptions(picker);
        var optionIndex = parseInt(input.dataset.comboOption, 10) - 1;
        testOptions[optionIndex] = input.value;
        var match = getResolvedVariant(picker, data, testOptions);
        setInputAvailability(input, !!(match && match.available));
      });

      var checked = fieldset.querySelector('input[type="radio"][data-combo-option]:checked');
      if (checked && checked.classList.contains('disabled')) {
        var firstAvailable = fieldset.querySelector('input[type="radio"][data-combo-option]:not(.disabled)');
        if (firstAvailable) firstAvailable.checked = true;
      }

      var selectedInput = fieldset.querySelector('input[type="radio"][data-combo-option]:checked');
      if (selectedInput) {
        var selectedLabel = picker.querySelector(
          '[data-combo-selected="' + picker.dataset.comboPicker + '-' + selectedInput.dataset.comboOption + '"]'
        );
        if (selectedLabel) selectedLabel.textContent = selectedInput.value;
      }
    });

    return getResolvedVariant(picker, data);
  }

  function initComboPicker(modal) {
    modal.querySelectorAll('[data-combo-picker]').forEach(function (picker) {
      if (picker.dataset.pickerBound === 'true') return;
      picker.dataset.pickerBound = 'true';
      updatePickerAvailability(picker);
      picker.addEventListener('change', function (event) {
        var input = event.target;
        if (!input.matches('input[type="radio"][data-combo-option]')) return;
        if (input.classList.contains('disabled')) {
          var fieldset = input.closest('.product-list-combo-picker__fieldset');
          var fallback = fieldset && fieldset.querySelector('input[type="radio"][data-combo-option]:not(.disabled)');
          if (fallback) fallback.checked = true;
          return;
        }
        updatePickerAvailability(picker);
        modal.querySelectorAll('[data-combo-picker]').forEach(function (otherPicker) {
          if (otherPicker !== picker) updatePickerAvailability(otherPicker);
        });
      });
    });
  }

  function getComboItemsFromModal(modal) {
    var items = [];
    var pickers = modal.querySelectorAll('[data-combo-picker]');
    if (!pickers.length) return null;

    for (var i = 0; i < pickers.length; i++) {
      var variant = updatePickerAvailability(pickers[i]);
      if (!variant || !variant.available) return null;
      items.push({
        id: variant.id,
        quantity: variant.quantity_min || 1
      });
    }

    return items;
  }

  function getRowItems(element) {
    var raw = element.getAttribute('data-items');
    if (raw) {
      try {
        return JSON.parse(raw);
      } catch (error) {
        return [];
      }
    }

    var itemsId = element.dataset.itemsId;
    if (!itemsId) return [];
    var jsonEl = document.getElementById(itemsId);
    if (!jsonEl) return [];
    try {
      return JSON.parse(jsonEl.textContent || '[]');
    } catch (error) {
      return [];
    }
  }

  function addComboItems(element, items, errorElement) {
    var secArr = JSON.parse(element.dataset.sections || '[]');
    var body = JSON.stringify({
      items: items,
      sections: secArr
        .map(function (section) {
          return section.id;
        })
        .join(','),
      sections_url: window.location.pathname
    });

    var config = fetchConfig('javascript');
    config.method = 'POST';
    config.headers['Content-Type'] = 'application/json';
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    config.body = body;

    if (typeof togglerLoader === 'function') togglerLoader(true);
    showComboError(errorElement, '');

    return fetch(routes.cart_add_url, config)
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        if (response.status) {
          showComboError(
            errorElement,
            response.description || response.message || 'Unable to add items to cart.'
          );
          return false;
        }
        if (!response.items && !response.sections) {
          showComboError(errorElement, 'Unable to add items to cart.');
          return false;
        }
        if (response.sections && typeof sectionArrRender === 'function') {
          sectionArrRender(secArr, response);
        }
        openCartDrawer(element);
        return true;
      })
      .catch(function (error) {
        console.error(error);
        showComboError(errorElement, 'Unable to add items to cart.');
        return false;
      })
      .finally(function () {
        if (typeof togglerLoader === 'function') togglerLoader(false);
      });
  }

  function bindComboModal(modal) {
    if (!modal || modal.dataset.comboBound === 'true') return;
    modal.dataset.comboBound = 'true';
    initComboPicker(modal);

    var confirmButton = modal.querySelector('[data-combo-modal-confirm]');
    var errorWrap = modal.querySelector('[data-combo-modal-error]');
    if (!confirmButton) return;

    confirmButton.addEventListener('click', function () {
      var atcElement = modal._comboAtcElement;
      if (!atcElement) return;

      var pickerCount = parseInt(modal.dataset.pickerCount || '2', 10);
      var items = getComboItemsFromModal(modal);
      if (!items || items.length < pickerCount) {
        showComboError(
          errorWrap,
          pickerCount === 1
            ? 'Please choose available options.'
            : 'Please choose available options for both bands.'
        );
        return;
      }

      addComboItems(atcElement, items, errorWrap).then(function (success) {
        if (success && typeof modal.close === 'function') {
          modal.close();
        }
      });
    });
  }

  function openComboModal(modalId, triggerButton, atcElement) {
    var modal = document.querySelector('[data-modal="' + modalId + '"]');
    if (!modal || typeof modal.open !== 'function') return;
    modal._comboAtcElement = atcElement;
    bindComboModal(modal);
    showComboError(modal.querySelector('[data-combo-modal-error]'), '');
    modal.open(triggerButton);
  }

  function handleAtcClick(event, atcElement, button) {
    event.preventDefault();
    if (button.disabled) return;

    if (atcElement.dataset.needsPicker === 'true' && atcElement.dataset.pickerModal) {
      openComboModal(atcElement.dataset.pickerModal, button, atcElement);
      return;
    }

    var items = getRowItems(atcElement);
    if (!items.length) return;

    addComboItems(atcElement, items, atcElement);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('product-list-combo-atc .product-list__button');
    if (!button) return;
    var atcElement = button.closest('product-list-combo-atc');
    if (!atcElement) return;
    handleAtcClick(event, atcElement, button);
  });

  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('[data-combo-picker]').forEach(function (picker) {
      picker.dataset.pickerBound = 'false';
    });
    document.querySelectorAll('.product-list-combo-modal').forEach(function (modal) {
      modal.dataset.comboBound = 'false';
    });
  });
})();
